import React, { useEffect } from "react";
import Aos from "aos";
import ImageZoom from "react-medium-image-zoom";
import "aos/dist/aos.css";
import "react-medium-image-zoom/dist/styles.css";
import "./Noticias.css"; // importa o CSS novo

const noticiasData = [
  {
    "data": "04/10/2025",
    "titulo": "Automotive Industry Week",
    "descricao": " Plastifa will be present at the '12th Automotive Industry Week', organized by AFIA! \nWe will be in the 'New York' room at the Solverde Hotel in Vila Nova de Gaia on November 4th, 5th, and 6th.",
    "imagem": "images/AFIA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_innovation-automotiveindustry-plastifa-activity-7378706061240926208-qsqS?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "02/10/2025",
    "titulo": "SCORING TOP 5%",
    "descricao": "Plastifa renews its status as 'TOP 5% Best SMEs in Portugal' — for the 6th consecutive year.\nWe are proud to announce the renewal of this distinction, awarded by SCORING.",
    "imagem": "images/TOP2025.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plastifa-top5-scoring-activity-7381254954105135104-Rcn0?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "01/09/2025",
    "titulo": "IAA MOBILITY 2025",
    "descricao": "PLASTIFA is pleased to participate in IAA MOBILITY 2025",
    "imagem": "images/IAA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plasticparts-mobility-automotive-activity-7360664420571578368-TTnd?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
{
    data: "15/05/2024",
    titulo: "ISO 14001",
    descricao:
      "With focus on the Environment and a more sustainable Future, Plastifa is now certified ISO 14001 - Environmental Management Systems.",
    imagem: "images/14001.jpeg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7196080381643616257",
  },
  {
    data: "23/12/2023",
    titulo: "A greener future",
    descricao:
      "With a focus on sustainability and a greener future, Plastifa takes the step of investing in solar energy production.",
    imagem: "images/PaineisSolares.JPG",
    link: "https://www.linkedin.com/posts/plastifa_com-foco-na-sustentabilidade-e-num-futuro-activity-7157008055249821696-QJP5?utm_source=share&utm_medium=member_desktop",
  },
  {
    data: "25/10/2023",
    titulo: "SCORING TOP 5%",
    descricao:
      "For the fourth consecutive year, the company was recognized as part of the TOP 5% BEST PME IN PORTUGAL in terms of Performance and Financial Strength",
    imagem: "images/TOP52023.png",
    zoom: true,
  },
  {
    data: "01/06/2023",
    titulo: "New Video",
    descricao:
      "In a world driven by constant progress and innovation, Plastifa is proud to make a brief presentation of the company with cutting-edge technology and innovative ideas.",
    imagem: "images/NotVideo.png",
    link: "https://www.linkedin.com/posts/plastifa_plastifa-your-partner-for-plastic-parts-activity-7059587841172865024-LQ9A?utm_source=share&utm_medium=member_desktop",
  },
  {
    data: "17/10/2022",
    titulo: "SCORING TOP 5%",
    descricao:
      "For the third consecutive year, the company was recognized as part of the TOP 5% BEST PME IN PORTUGAL in terms of Performance and Financial Strength.",
    imagem: "images/TOPSCORING22.png",
    zoom: true,
  },
  {
    data: "23/12/2021",
    titulo: "Christmas Postcard",
    descricao: "Please click on the image below to access Plastifa Postcard:",
    imagem: "images/Natal-EN.png",
    link: "https://plastifa.pt/Christmas",
  },
  {
    data: "15/11/2021",
    titulo: "SCORING TOP 5%",
    descricao:
      "For the second consecutive year, the company was recognized as part of the TOP 5% BEST PME IN PORTUGAL in terms of Performance and Financial Strength.",
    imagem: "images/TOP2021.jpg",
    zoom: true,
  },
  {
    data: "24/04/2021",
    titulo: "PME Excelência",
    descricao: "Plastifa renews the PME Excelência status for the 7th consecutive year.",
    imagem: "images/PMEex3.png",
    zoom: true,
  },
  {
    data: "24/12/2020",
    titulo: "SCORING TOP 5%",
    descricao:
      "The company was recognized as part of the TOP 5% BEST PME IN PORTUGAL in terms of Performance and Financial Strength!",
    imagem: "images/TOP52020.jpg",
    zoom: true,
  },
  {
    data: "16/04/2020",
    titulo: "EPI’s Plastifa",
    descricao:
      "In order to play its part in the fight against the Covid 19 Pandemic, Plastifa has dedicated itself to the manufacture of Face-shields and Mask Fasteners.",
    imagem: "images/Viseiras.png",
    zoom: true,
  },
  {
    data: "02/10/2020",
    titulo: "Expansion to Plastifa Plant 2",
    descricao: "Plastifa moved towards the expansion of 1000 m2 of Plant 2.",
    imagem: "images/ExpUn2.jpeg",
  },
];

const Noticias = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  return (
    <div className="noticias-wrapper">
      <div className="noticias-grid">
        {noticiasData.map((noticia, idx) => (
          <article key={idx} className="noticia-card" data-aos="fade-up">
            <div className="noticias-row2">
              <label>{noticia.data}</label>
              <h3 className="noticia-titulo">{noticia.titulo}</h3>
            </div>
            <p
              className="noticia-desc"
              dangerouslySetInnerHTML={{
                __html: noticia.descricao.replace(/\n/g, "<br>")
              }}
            ></p>
            <div className="noticia-media">
              {noticia.zoom ? (
                <ImageZoom
                  image={{ src: noticia.imagem, alt: noticia.titulo, className: "noticia-img" }}
                  zoomImage={{ src: noticia.imagem, alt: noticia.titulo }}
                />
              ) : noticia.link ? (
                <a href={noticia.link} target="_blank" rel="noreferrer">
                  <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
                </a>
              ) : (
                <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Noticias;